import { useContext } from "react";
import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";

import { LottieAnimation } from "@manifesthhqinc/ui-library";
import { HenryLoadingContainer, HenryLottieContainer } from "../henry-questionniare/screens/styles";
import Spacing from "../../layout/spacing";
import { BodyLargeRegular, HeadlineMedium } from "../../components/font";

import { AppContext } from "../../context/AppContext";
import { BRIDGE_PRODUCTION } from "../../typings";
import { TransferContext } from "../../context/TransferContext";
import { STEP_ANNUITY_CONTACT, STEP_SCHEDULE_PHONE_CALL_NO_LOADING } from "../../class/transferDetails";

// THIS INTERIM SCREEN will check and route user to whether need a phone call screen
const SchedulePhoneCallFlashLoading = ({}) => {
  const { appEnv, flow } = useContext(AppContext);
  const { isPhoneCallNeeded, goToScreen, navigateToHomeScreen } = useContext(TransferContext);

  const onNext = () => {
    if (isPhoneCallNeeded && appEnv === BRIDGE_PRODUCTION) {
      goToScreen(STEP_SCHEDULE_PHONE_CALL_NO_LOADING);
    } else if (flow === "Annuity") {
      goToScreen(STEP_ANNUITY_CONTACT);
    } else {
      navigateToHomeScreen();
    }
  };
  if (appEnv !== BRIDGE_PRODUCTION) {
    onNext();
  }

  if (appEnv === BRIDGE_PRODUCTION) {
    // if phone call not needed > go to next screen (Home or Annuity contact)
    if (!isPhoneCallNeeded) {
      onNext();
    }
    // if phone call needed > show Assigning you a specialist screen
    if (isPhoneCallNeeded) {
      return (
        <TransitionWrapper>
          <HenryLoadingContainer $maxWidth="330px">
            <HenryLottieContainer>
              <LottieAnimation
                type="three-dot-loading"
                autoplay
                onComplete={onNext}
                height={200}
                width={200}
                loop={0.5}
              />
            </HenryLottieContainer>
            <Spacing vertical="11" />
            <HeadlineMedium $textAlign="center">Assigning your specialist...</HeadlineMedium>
            <Spacing vertical="8" />
            <BodyLargeRegular $textAlign="center">
              Your account provider requires <br />a phone call.{" "}
            </BodyLargeRegular>
          </HenryLoadingContainer>
        </TransitionWrapper>
      );
    }

    return <></>;
  }
  return <></>;
};

export default SchedulePhoneCallFlashLoading;
